<div id="Location">
    <div class="field">
        <div class="mb-2">
            <label id="titleLabel" i18n="@@location-edit-lib.location.edit.field.title">Name</label>
        </div>

        <p-autoComplete #autocomplete [(ngModel)]="selectedLocation" inputId="title" ariaLabelledBy="titleLabel" field="title" [suggestions]="searchedLocations"
                        dataKey="address" (completeMethod)="searchPlaces($event)" [style]="{'width':'100%'}" [delay]="200"
                        (onSelect)="onSearchPlaceSelected($event.value)" [inputStyle]="{'width':'100%'}" [forceSelection]="false"
                        [minLength]="5">
            <ng-template let-loc #item>
                <div class="location-item">
                    <div class="font-semibold">{{loc.title}}</div>
                    <div>{{loc.address}}</div>
                </div>
            </ng-template>
        </p-autoComplete>
    </div>

    <div class="grid">
        <div class="col-12 md:col-6">
            <label for="street" i18n="@@location-edit-lib.location.edit.field.street">Street</label>
            <input pInputText id="street" type="text" class="inputfield w-full"
                [(ngModel)]="locationContext.street">
        </div>

        <div class="col-12 md:col-3">
            <label for="postalCode" i18n="@@location-edit-lib.location.edit.field.postalCode">Postal
                Code</label>
            <input pInputText id="postalCode" type="text" class="inputfield w-full"
                [(ngModel)]="locationContext.postalCode">
        </div>
        <div class="col-12 md:col-3">
            <label for="city" i18n="@@location-edit-lib.location.edit.field.city">City</label>
            <input pInputText id="city" type="text" class="inputfield w-full"
                [(ngModel)]="locationContext.city">
        </div>

        <div class="col-12 md:col-6">
            <label id="latitudeLabel" i18n="@@location-edit-lib.location.edit.field.latitude">Latitude</label>
            <div>
                <p-inputNumber [(ngModel)]="locationContext.geoLat" mode="decimal" [maxFractionDigits]="8"
                            [style]="{'width':'100%'}" class="w-full" ariaLabelledBy="latitudeLabel">
                </p-inputNumber>
            </div>


        </div>
        <div class="col-12 md:col-6">
            <label id="longitudeLabel" i18n="@@location-edit-lib.location.edit.field.longitude">Longitude</label>
            <div>
                <p-inputNumber [(ngModel)]="locationContext.geoLng" mode="decimal" [maxFractionDigits]="8"
                            [style]="{'width':'100%'}" class="w-full" ariaLabelledBy="longitudeLabel">
                </p-inputNumber>
            </div>
        </div>

        <div class="col-12 md:col-12">
            <label id="externalIdLabel" i18n="@@location-edit-lib.location.edit.field.externalId">externe UID</label>
            <input pInputText id="externalId" type="text" class="inputfield w-full"
                   [(ngModel)]="locationContext.externalId">
        </div>

    </div>

    <div class="flex mt-3">
        <p-button severity="secondary"
                (click)="onCancelEdit()" label="Cancel"
                i18n-label="@@location-edit-lib.location.edit.cancel"></p-button>
        <div class="ml-auto">
            <p-button severity="secondary" i18n-label="@@location-edit-lib.location.edit.save" label="Save"
                    [disabled]="locationContext.title == ''"
                    (click)="onAddOrUpdateLocation(locationContext)"></p-button>
        </div>
    </div>
</div>
